
import Layout from '@/layout'
import dataCenter from '@/page/dataCenter'
// import user from '@/store/user/index'
// import dic from '@/utils/menuDic'
/**
 * @description 渲染路由
 * @param constantRoutes
 * @returns {*}
 */
let dataCenterPermis = []
export function filterRoutes (constantRoutes) {
  // constantRoutes.sort((a, b) => { return a.orderNum - b.orderNum })
  let menuRouters = []
  dataCenterPermis = []
  constantRoutes.forEach((m, i) => {
    let module = {
      path: m.url,
      component: m.flag === 1 ? Layout : dataCenter,
      name: m.url.slice(m.url.lastIndexOf('/')),
      // eslint-disable-next-line eqeqeq
      meta: { title: m.name },
      children: m.children && m.children.length ? convertTree(m.children) : []
    }
    menuRouters.push(module)
  })
  return {menuRouters, dataCenterPermis}
}
function convertTree (routers) {
  // if (routers.length == 1) {

  // }
  let children = []
  routers.forEach((m, i) => {
    let component = m.component
    if (m.flag === 2) dataCenterPermis.push(component)
    let module = {
      path: (m.flag === 2 && i === 0) ? '/dataCenter/dataHome' : m.url,
      component: () => import(`@/page/${component}`),
      name: m.url.slice(m.url.lastIndexOf('/') + 1),
      meta: { title: m.name }
    }
    if (m.children && (m.children.length)) module.children = convertTree(m.children)
    // if ((m.url === '/rollsHomework/productionDateEntry' && user.state.userinfo.isMdOpen === 1) || (m.url === '/rollsHomework/productionDateEntry' && user.state.userinfo.identity === 4)) {
    //   children.push(module) // 注入生产日期管理菜单
    // } else if ((m.url === '/rollsHomework/putawayList' && user.state.userinfo.isLmOpen === 1) || (m.url === '/rollsHomework/putawayList' && user.state.userinfo.identity === 4)) {
    //   children.push(module) // 注入上架单菜单
    // } else if (m.url !== '/rollsHomework/productionDateEntry' && m.url !== '/rollsHomework/putawayList') {
    //   children.push(module) // 注入其他菜单
    // }
    children.push(module) // 注入其他菜单
  })
  return children
}



// WEBPACK FOOTER //
// ./src/utils/filterRoutes.js